import React, { FC } from 'react';

interface ProgressBarProps {
  currentTime: number;
  totalTime: number;
  isActive: boolean;
}

const ProgressBar: FC<ProgressBarProps> = ({ currentTime, totalTime, isActive }) => {
  const progress = (currentTime / totalTime) * 100;
  
  return (
    <div className="mb-4">
      <div className="relative pt-1">
        <div className="flex mb-2 items-center justify-between">
          <div>
            <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-indigo-600 bg-indigo-200">
              {isActive ? 'Writing in progress' : 'Ready'}
            </span>
          </div>
          <div className="text-right">
            <span className="text-xs font-semibold inline-block text-indigo-600">
              {Math.ceil(currentTime)}s / {totalTime}s
            </span>
          </div>
        </div>
        <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-indigo-200">
          <div
            style={{ width: `${progress}%` }}
            className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-indigo-600 transition-all duration-300"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar; 